import { AnalyticsSpend } from "@stories/pages/Contractor/Analytics/AnalyticsSpend";

export const AnalyticsSpendView = () => {
  return <AnalyticsSpend />;
};
